import React, {useState, Fragment} from 'react'
import Layout from '../Layout/Layout'
import { Block } from '../../styles/commons'
import SoureOfFundsDetail from '../SourceOfFundsDetailScreen/SourceOfFundsDetailScreen'
import SoureOfFundsUserScreen from '../SourceOfFundsUserScreen/SourceOfFundsUserScreen'

const AdminScreen = props => {
  const [sofUserId, setSofUserId] = useState('')
  return (
    <Layout>
      <Block>
        <SoureOfFundsDetail setIsAdmin={props.setIsAdmin} sofUserId={sofUserId} setSofUserId={setSofUserId}/>
        {sofUserId !== '' &&
          <Fragment>
            <SoureOfFundsUserScreen sofUserId={sofUserId} setSofUserId={setSofUserId} add={sofUserId==='add'}/>
          </Fragment>
        }
      </Block>
    </Layout>
  )
}
export default AdminScreen
